<div class="nav_fixed-header">
    <div class="auto-container">
        <nav class="navbar navbar-expand-lg navbar-dark">
            <a class="navbar-brand" href="./#/home">
                <img src="assets/images/logo.png" alt="">
            </a>
            <button id="btnTopMenu" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main_nav"
                aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="main_nav">

               

                <ul class="navbar-nav" *ngIf="showMenu">
                    <li class="nav-item mr-3"
                        [ngClass]="{'dropdown': menu.menuItems !== null, 'show': menu.expand == true}"
                        *ngFor="let menu of menuData">
                        <!-- <a class="nav-link" [ngClass]="{'dropdown-toggle': menu.menuItems !== null}" class="nav-link"  style="cursor:pointer;" *ngIf="menu.url !== null && menu.url !== undefined && menu.menuItems !== null && menu.label !== 'Home'" [routerLink]="menu.url">{{menu.label}}</a> -->
                        <a class="nav-link" [ngClass]="{'dropdown-toggle': menu.menuItems !== null}" class="nav-link"
                            style="cursor:pointer;"
                            *ngIf="menu.url !== null && menu.url !== undefined && menu.menuItems !== null && menu.label !== 'Home'"
                            (click)="expandMenu(menu)">{{menu.label}}</a>
                        <a class="nav-link" [ngClass]="{'dropdown-toggle': menu.menuItems !== null}"
                            style="cursor:pointer;"
                            *ngIf="menu.url !== null && menu.url !== undefined && menu.label == 'Home'"
                            [routerLink]="menu.url" (click)="expandMenu(menu)">{{menu.label}}</a>
                        <a class="nav-link" [ngClass]="{'dropdown-toggle': menu.menuItems !== null}"
                            style="cursor:pointer;" *ngIf="menu.url == null || menu.url == undefined"
                            (click)="expandMenu(menu)">{{menu.label}}</a>
                        <ul class="dropdown-menu fade-up" [ngClass]="{'show': menu.expand == true}"
                            *ngIf="menu.menuItems !== null">
                            <li *ngFor="let item of menu.menuItems">
                                <a class="dropdown-item" *ngIf="item.route !== null" (click)="hideAndShowMenu(menu)"
                                    [routerLink]="item.route">{{item.name}}</a>
                                <a class="dropdown-item" *ngIf="item.route == null" target="_blank"
                                    [href]="item.url">{{item.name}}</a>
                            </li>
                        </ul>
                    </li>
                </ul>


                <ul class="navbar-nav ml-auto">
                    <!-- <li class="nav-item"><a class="nav-link" href="#"> Menu item </a></li>-->
                    <li class="nav-item nav-box">
                        <a *ngIf="!authenticated" routerLink="./login"
                            class="nav-link nav-toggler navSidebar-button">Login</a>
                    </li>

                    <li class="nav-item dropdown profile" *ngIf="authenticated">
                        <a class="nav-link " href="#" data-toggle="dropdown">
                            <span class="text"><i class="fas fa-th-large"></i></span>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-right fade-down">
                            <li>
                                <a class="dropdown-item" [routerLink]="['/change-password']">Change Password</a>
                            </li>
                            <li><a class="dropdown-item" (click)="logout()">Logout</a></li>
                        </ul>
                    </li>

                </ul>

            </div> <!-- navbar-collapse.// -->

        </nav>
    </div>
</div>
<app-loader></app-loader>